module.exports = __webpack_public_path__ + "static/media/save-sketch.95aec249.svg";